import React,{useState,useEffect} from 'react'
import Page from "../../components/Page"
import Loader from '../../components/Loader/Loader'
import ShimmerNotification from "../../components/Layouts/ShimmerNotification";
import ShimmerCardBodyThree from "../../components/Layouts/ShimmerCardBodyThree";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  SessionKeys,
} from "../../utils/AppUtils";
import VideoCoursesListingCard from '../videoCourses/VideoCoursListingCard';
import { providerCoaching, providerList} from "../../redux/provider/actions";
import MenuCoaching from '../../components/MenuCoaching';
import { useLocation } from 'react-router-dom';



const SORT_BY = [
  { id: 1, value: "A to Z" },
  { id: 2, value: "Z to A" },
];
export default function OtherServices() {

    
    const dispatch = useDispatch();
   
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const catId = params.get('catId');
    const providerId = params.get('provider_id');

    const [sortBy, setSortBy] = useState(SORT_BY[0].id);
    const [isOwnCategoryClick, setIsOwnCategoryClick] = useState(false)
  const [isLoading, setIsLoading] = useState(true);
  const [subCategories, setSubCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [innerCategoryName, setInnerCategoryName] = useState("");
  const [coursesList, setCoursesList] = useState([]);

  const [providersData, setprovidersData] = useState([]);
  const [providerCoachingData, setproviderCoachingData] = useState();
  const [search_input, setsearch_input] = useState("");
  const [selectedSort, setselectedSort] = useState("ASC");
  const authBroker = useSelector((state) => state.auth.authBroker);

  const location = useLocation();
  const type = location.state?.type;
  const name = location.state?.name;

  useEffect(() => {
    providerId ? provider_coaching(providerId) :all_other_services();
  }, [type]);

  const provider_list = () => {
    setIsLoading(true);
    dispatch(providerList({
      postData: {
          token:localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          sort_by:selectedSort? selectedSort:"ASC",
      },
   })
  );
  }

  const onClickSortBy = (e) => {
    const value = e.target.value;
    console.log("selected sort value",value);
    setSortBy(value);
    if(value==="1")
    {
      setselectedSort("ASC");
    }
    else if(value==="2")
    {
      
       setselectedSort("DESC");
    }
  };
 
  useEffect(() => {
    provider_list();
    providerId ? provider_coaching(providerId) :all_other_services();
   }, [selectedSort]);

   
  useEffect(() => {
    if (search_input !== undefined && search_input.length > 2)  { 
    providerId ? provider_coaching(providerId) :all_other_services();
    }
    if(search_input === null || search_input === "") {
     
     providerId ? provider_coaching(providerId) :all_other_services();
    }
  }, [search_input]);

  const provider_coaching = (providerId) => {
    setIsLoading(true);
    setallCoaching(false);
    dispatch(providerCoaching({
      postData: {
          token:localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          provider_id:providerId,
          type:type,
          search:search_input,
          sort_by:selectedSort? selectedSort:"ASC",
      },
   })
  );
  }

  const [allCoaching, setallCoaching] = useState(false);

  const all_other_services = () => {
    setIsLoading(true);
    setallCoaching(true);
    dispatch(providerCoaching({
      postData: {
          token:localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          type:"other",
          search:search_input,
          sort_by:selectedSort? selectedSort:"ASC",
      },
   })
  );
  }

  const providerCoachingResponse =  useSelector((state) => state.provider.providerCoachingResponse);
  console.log("coaching response",providerCoachingResponse);

  useEffect(() => {
    if (!_.isEmpty(providerCoachingResponse)) {
        if (providerCoachingResponse.status === "success") {
         console.log("List",providerCoachingResponse?.payload?.data?.data?.List);
            setproviderCoachingData(providerCoachingResponse?.payload?.data?.data?.List);
            setCategoryName(allCoaching  ? "All Partners" : providerCoachingResponse?.payload?.data?.data?.List[0]?.provider?.provider_name);
           setInnerCategoryName(allCoaching  ? "All Partners" :providerCoachingResponse?.payload?.data?.data?.List[0]?.provider?.provider_name);
           setIsLoading(false);
        } else {
            setproviderCoachingData();
            setIsLoading(false);
        }
    }
}, [ providerCoachingResponse]);

  
  
  useEffect(() => {
      provider_list();
      //provider_coaching(providerId);
     providerId? provider_coaching(providerId) : all_other_services();
  }, []);

  const providersDataResponse = useSelector((state)=>state.provider.providersDataListRes);
  console.log("providers data",providersDataResponse);
  useEffect(() => {
        if (!_.isEmpty(providersDataResponse)) {
            if (providersDataResponse.status === "success") {
                setprovidersData(providersDataResponse.payload.data.flatMap(item =>
                  item.providerList.map(provider => ({
                    provider_id: provider.provider_id,
                    provider_name: provider.provider_name
                  }))
                ));
            } else {
                setprovidersData();
            }
        }
    }, [providersDataResponse]);
    const [selectedProvider, setSelectedProvider] = useState();

const goToCoaching = (provider_id,provider_name) => {
   setSelectedProvider(provider_id);
   setCategoryName(provider_name);
   setInnerCategoryName(provider_name);
   if(provider_id==="All")
   {
    all_other_services();
   }
   else
   {
   provider_coaching(provider_id);
   }
}

const maxLength = 13;

  return (
   <>
    <Loader start={isLoading} />
      <Page>
        {providerId ? <MenuCoaching providerId={providerId} selectedItem={6} showBanner={false} /> : ''}
      <div className="my-credit-points video-page-rsp">
          <section className="container">
            <div className="row">
              <div className="col-md-12 profile-left-sec">
                <div className="search_heading">
                  <p className="lable-heading_search">{ name ? name : "Other Services"}</p>
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-3 search__input">
                <div className="input-lear position-relative d-flex">
                  <label htmlFor="sortBy" className="input__label">
                    Sort by
                  </label>
                  <select
                    className={`form-select input_searchfield ${isLoading ? "not-allowed" : ""}`}
                    aria-label="Default select example"
                    value={sortBy}
                    onChange={onClickSortBy}
                  >
                    {SORT_BY.map((item, index) => {
                      return (
                        <option selected={sortBy === item?.id ? true : false} key={index} value={item.id}>
                          {item.value}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              <div className="col-md-3 search__input">
                <div className="input-lear position-relative d-flex">
                  <label htmlFor="search" className="input__label">
                    Search
                  </label>
                  <input
                    type="text"
                    id="search"
                    name="search"
                    className={`input_searchfield_search ${isLoading ? "not-allowed" : ""}`}
                    onChange={(evt) => {
                      setsearch_input(evt.target.value);
                    }}
                  />
                  <button
                    className={`button-reset ${isLoading ? "not-allowed" : ""}`}
                    style={{ marginTop: "-20px" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      id="Find"
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                    >
                      <defs>
                        <linearGradient
                          id="linear-gradient"
                          y1="0.5"
                          x2="1"
                          y2="0.5"
                          gradientUnits="objectBoundingBox"
                        >
                          <stop offset="0" stopColor="#415385" />
                          <stop offset="1" stopColor="#415385" />
                        </linearGradient>
                      </defs>
                      <circle
                        id="Ellipse_191"
                        data-name="Ellipse 191"
                        cx="15"
                        cy="15"
                        r="15"
                        fill="url(#linear-gradient)"
                      />
                      <circle
                        id="Ellipse_192"
                        data-name="Ellipse 192"
                        cx="13"
                        cy="13"
                        r="13"
                        transform="translate(2 2)"
                        fill="#fff"
                      />
                      <path
                        id="Icon_awesome-search"
                        data-name="Icon awesome-search"
                        d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z"
                        transform="translate(7.715 7.714)"
                        fill="#415385"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-3">
                {providerId ?  <>
                  <div className="side-navbar active-nav d-flexs flex-wrap flex-column">
  <div className="nav-box-sidebar d-flex gap-2">
           <ul className="nav side-nav-custom opennav flex-column w-100">
<li className={"nav-link"} >
            <span className="mx-2" key="All">{ name ? name : "Other Services"}</span>
        </li>
</ul>
</div>
</div>
           </>    :  providersData.length!=0 ? 

<div className="side-navbar active-nav d-flexs flex-wrap flex-column">
<div className="nav-box-sidebar d-flex gap-2">
    <div className={`nav-side-title cursor-pointer ${isLoading ? "not-allowed" : ""}`} onClick={() => {
goToCoaching("All")
    }}>
      Partners
    </div>
    <button className="openbtn" id="openbtnNav"
        // ref={hamburgerMenu}
        // onClick={() => {
        //     toggleSideNav();
        // }}
        >
        <span className="closetoogle"></span>
    </button>
</div>
<ul className="nav side-nav-custom opennav flex-column w-100">
<li className={selectedProvider === "All" ? "nav-link active" : "nav-link"} onClick={()=>goToCoaching("All")}>
            <span className="mx-2" key="All">All</span>
        </li>
    {!_.isEmpty(providersData) && providersData.map((item, index) => {
        return <li className={selectedProvider === item.provider_id ? "nav-link active" : "nav-link"} onClick={()=>goToCoaching(item.provider_id,item.provider_name)}>
             <span className="mx-2" key={item.provider_id}>{item?.provider_name.length > maxLength ? <div dangerouslySetInnerHTML={{ __html: item?.provider_name.slice(0, maxLength) + "..."  }} /> : <div dangerouslySetInnerHTML={{ __html: item?.provider_name }} /> }</span>
          </li>
    })}
</ul>
</div>


  :
               <>
                  <div className="row">
                    {
                      [1, 2].map(n => {
                        return (
                          <ShimmerNotification />
                        )
                      })
                    }
                  </div>
                </>}
              </div>
              <div className="col-md-9">
                {!isLoading ? 
                <VideoCoursesListingCard
                  innerCategoryName={innerCategoryName}
                  coursesList={providerCoachingData}
                  isLoading={isLoading}
                  isProviderListing={true}
                /> : <>
                  <div className="row videolistbox">
                    {
                      [1, 2, 3].map(i => {
                        return (
                          <ShimmerCardBodyThree key={`shimmer-${i}`} />
                        )
                      })
                    }
                  </div>
                </>}
              </div>
              </div> 

</section>
</div>
      </Page>
   </>
  )
}
